(() => {
  // --- Config ---
  const LINK_SELECTOR = '.summary-extract, [data-extract-link], [data-open="modal"]';
  const EXTRACT_SELECTOR = '.ilion, .ilion-content, #ilion';
  const MODAL_ID = 'summary-to-table-extract-modal';

  // ---------- DOM utils ----------
  const createEl = (tag, attrs = {}, children = []) => {
    const el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === 'class') el.className = v;
      else if (k === 'html') el.innerHTML = v;
      else el.setAttribute(k, v);
    });
    children.forEach(c => el.appendChild(c));
    return el;
  };

  function buildModal() {
    let existing = document.getElementById(MODAL_ID);
    if (existing) return existing;

    const overlay = createEl('div', {
      id: MODAL_ID,
      class: 'summary-modal-overlay',
      'aria-hidden': 'true'
    });

    overlay.innerHTML = `
      <div class="summary-content" role="document">
        <div class="summary-header">
          <h2 class="summary-title"></h2>
          <span class="summary-close" aria-label="Close modal">&times;</span>
        </div>
        <div class="summary-scroll">
          <div class="summary-spinner" aria-hidden="true">Loading…</div>
          <div class="summary-body"></div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    attachModalHandlers(overlay);
    return overlay;
  }

  function attachModalHandlers(modal) {
    const close = () => {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('open');
      modal.querySelector('.summary-body').innerHTML = '';
      modal.querySelector('.summary-title').textContent = '';
      document.documentElement.style.overflow = '';
    };
    modal.querySelector('.summary-close').addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  }

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.summary-close');
    if (closeBtn) closeBtn.focus();
  }

  function showSpinner(modal, show = true) {
    const spinner = modal.querySelector('.summary-spinner');
    if (spinner) spinner.style.display = show ? '' : 'none';
  }

  function loadInIframe(url, modal, title) {
    const content = modal.querySelector('.summary-body');
    if (!content) return;
    content.innerHTML = `<iframe src="${url}" style="width:100%;height:70vh;border:none;"></iframe>`;
    modal.querySelector('.summary-title').textContent = title || '';
    openModal(modal);
  }

  // ---------- SVG icons ----------
const fileIcon = (type = 'file', size = 12) => {
    const colors = {
      pdf: { badge: "#E53935", text: "PDF" },
      doc: { badge: "#1E88E5", text: "DOC" },
      xls: { badge: "#2E7D32", text: "XLS" },
      csv: { badge: "#6D4C41", text: "CSV" },
      file:{ badge: "#009cd6", text: "FILE" },
    };
    const c = colors[type] || colors.file;
    return `
    <svg viewBox="0 0 64 64" width="${size}" height="${size}"
         aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 6h25l12 12v36a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6z"
              fill="#F4F6F8" stroke="#009cd6" stroke-linejoin="round"/>
        <path d="M39 6v10a6 6 0 0 0 6 6h10L39 6z" fill="#e5f5fb"/>
        <rect x="18" y="26" width="28" height="2" rx="1.5" fill="#009cd6"/>
        <rect x="18" y="32" width="24" height="2" rx="1.5" fill="#009cd6"/>
        <rect x="18" y="38" width="20" height="2" rx="1.5" fill="#009cd6"/>
        <rect x="16" y="51" width="28" height="12" rx="6" fill="${c.badge}"/>
        <text x="30" y="60" text-anchor="middle" font-size="9"
              font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial"
              fill="#FFFFFF" font-weight="700" letter-spacing=".5">${c.text}</text>
      </svg>
    `;
  };

  const detectFileType = (href = '', label = '') => {
    const h = (href || '').toLowerCase();
    const l = (label || '').toLowerCase();
    if (h.endsWith('.pdf') || l.includes('pdf')) return 'pdf';
    if (/\.(docx?|rtf)(\?|$)/.test(h) || l.includes('word')) return 'doc';
    if (/\.(xlsx?|xlsm)(\?|$)/.test(h) || l.includes('excel')) return 'xls';
    if (h.endsWith('.csv') || l.includes('csv')) return 'csv';
    return 'file';
  };

  // ---------- “language table” helpers ----------
  function scoreLanguageTable(table) {
    const txt = (table.textContent || '').toLowerCase();
    const langs = ['english','arabic','chinese','español','espanol','français','francais','russian'];
    const keys  = ['pdf','word','posted','format','size'];
    let s = 0;
    langs.forEach(l => { if (txt.includes(l)) s += 2; });
    keys.forEach(k => { if (txt.includes(k)) s += 1; });
    if (table.rows && table.rows.length >= 6) s += 2;
    return s;
  }

  function pickLanguageTable(doc) {
    const tables = Array.from(doc.querySelectorAll('table'));
    let best = null, bestScore = 0;
    for (const t of tables) {
      const sc = scoreLanguageTable(t);
      if (sc > bestScore) { best = t; bestScore = sc; }
    }
    return bestScore >= 6 ? best : null;
  }

  function stripLegacyAttrs(root) {
    const rm = ['bgcolor','align','border','cellpadding','cellspacing','width','height','valign','style'];
    root.querySelectorAll('*').forEach(el => rm.forEach(a => el.removeAttribute(a)));
  }

  function normalizeLinks(root) {
    root.querySelectorAll('a[href]').forEach(a => {
      a.setAttribute('target','_blank');
      a.setAttribute('rel','noopener noreferrer');
    });
  }

  function minimalizeTable(table) {
    const clean = table.cloneNode(true);
    clean.querySelectorAll('script, style, font').forEach(n => n.remove());
    stripLegacyAttrs(clean);
    normalizeLinks(clean);
    clean.classList.add('stt-lang-table');
    clean.querySelectorAll('th').forEach(th => th.classList.add('stt-th'));
    clean.querySelectorAll('td').forEach(td => td.classList.add('stt-td'));
    return clean;
  }

  // --- normalize (Language | PDF | Word | Posted) ---
  const LANG_NAMES = ['English','Arabic','Chinese','Español','Espanol','Français','Francais','Russian'];

  function isLangRow(tr) {
    const raw = (tr.textContent || '');
    const t = raw
      .replace(/\u00a0/g, ' ')
      .replace(/\[[^\]]*\]/g, '')
      .replace(/[():.]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    return LANG_NAMES.some(L => new RegExp(`^${L}$`, 'i').test(t));
  }

  function extractCellsInfo(tr) {
    const txt = (tr.textContent || '').trim();
    const dateMatch = txt.match(/\b\d{4}-\d{2}-\d{2}\b/);
    const date = dateMatch ? dateMatch[0] : '';
    const links = Array.from(tr.querySelectorAll('a[href]')).map(a => {
      const label = (a.textContent || '').trim().toLowerCase();
      const href = a.getAttribute('href');
      const isPDF = label.includes('pdf') || /\.pdf(\?|$)/i.test(href || '');
      const isWord = label.includes('word') || /\.docx?(\?|$)/i.test(href || '');
      return { a, href, isPDF, isWord };
    });
    const pdf = links.find(l => l.isPDF);
    const doc = links.find(l => l.isWord);
    return { date, pdf, doc };
  }

  function buildNormalizedLangTable(rawTable) {
    const rows = Array.from(rawTable.querySelectorAll('tr'));
    const items = [];
    let currentLang = null;

    for (const tr of rows) {
      const cells = Array.from(tr.querySelectorAll('td,th'));

      // A) ligne ne contenant que la langue
      if (isLangRow(tr)) {
        currentLang = (tr.textContent || '').trim();
        continue;
      }

      // B) langue dans la 1re cellule de la même ligne
      let firstCellLang = null;
      if (cells.length >= 2) {
        const firstTxt = (cells[0].textContent || '')
          .replace(/\u00a0/g,' ')
          .replace(/\[[^\]]*\]/g,'')
          .replace(/[():.]/g,'')
          .replace(/\s+/g,' ')
          .trim();
        const hit = LANG_NAMES.find(L => new RegExp(`^${L}$`, 'i').test(firstTxt));
        if (hit) {
          firstCellLang = hit;
          currentLang = hit;
        }
      }
      if (!currentLang) continue;

      const extractScope = firstCellLang ? (() => {
        const clone = tr.cloneNode(true);
        const first = clone.querySelector('td,th');
        if (first) first.remove();
        return clone;
      })() : tr;

      const { date, pdf, doc } = extractCellsInfo(extractScope);
      if (!(pdf || doc)) continue;

      let item = items.find(x => x.lang === currentLang);
      if (!item) { item = { lang: currentLang, pdf: null, doc: null, posted: date || '' }; items.push(item); }
      if (pdf && !item.pdf) item.pdf = pdf;
      if (doc && !item.doc) item.doc = doc;
      if (!item.posted && date) item.posted = date;
    }

    // table HTML
    const out = document.createElement('table');
    out.className = 'stt-lang-table';
    const thead = document.createElement('thead');
    thead.innerHTML = `<tr>
      <th class="stt-th">Language</th>
      <th class="stt-th">PDF</th>
      <th class="stt-th">Word</th>
      <th class="stt-th">Posted</th>
    </tr>`;
    out.appendChild(thead);

    const tbody = document.createElement('tbody');
    items.forEach(it => {
      const tr = document.createElement('tr');

      const tdLang = document.createElement('td');
      tdLang.className = 'stt-td';
      tdLang.textContent = it.lang;

      const tdPDF = document.createElement('td');
      tdPDF.className = 'stt-td';
      if (it.pdf) {
        const a = it.pdf.a.cloneNode(true);
        a.setAttribute('target','_blank');
        a.setAttribute('rel','noopener noreferrer');
        const type = detectFileType(a.getAttribute('href') || '', a.textContent);
        const ico = document.createElement('span');
        ico.className = 'stt-ico';
        ico.innerHTML = fileIcon(type, 12); // 12 = tout petit
        a.textContent = a.textContent.trim() || type.toUpperCase();
        tdPDF.appendChild(ico);
        tdPDF.appendChild(a);
      } else {
        tdPDF.textContent = '—';
      }

      const tdWord = document.createElement('td');
      tdWord.className = 'stt-td';
      if (it.doc) {
        const a = it.doc.a.cloneNode(true);
        a.setAttribute('target','_blank');
        a.setAttribute('rel','noopener noreferrer');
        const type = detectFileType(a.getAttribute('href') || '', a.textContent);
        const ico = document.createElement('span');
        ico.className = 'stt-ico';
        ico.innerHTML = fileIcon(type);
        a.textContent = a.textContent.trim() || type.toUpperCase();
        tdWord.appendChild(ico);
        tdWord.appendChild(a);
      } else {
        tdWord.textContent = '—';
      }

      const tdPosted = document.createElement('td');
      tdPosted.className = 'stt-td';
      tdPosted.textContent = it.posted || '';

      tr.append(tdLang, tdPDF, tdWord, tdPosted);
      tbody.appendChild(tr);
    });
    out.appendChild(tbody);
    return out;
  }

  // ---------- fetch + extract ----------
  async function loadAndInject(url, selectors, modal) {
    showSpinner(modal, true);
    try {
      const res = await fetch(url, { credentials: 'omit' });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      // Certaines pages ITU sont en ISO-8859-1
      const buffer = await res.arrayBuffer();
      const decoder = new TextDecoder('iso-8859-1');
      const text = decoder.decode(buffer);
      const doc = new DOMParser().parseFromString(text, 'text/html');

      // 1) sélecteur utilisateur prioritaire
      for (const sel of selectors) {
        const found = doc.querySelector(sel);
        if (found) {
          found.querySelectorAll('script, style').forEach(n => n.remove());
          return found.outerHTML;
        }
      }

      // 2) tableau des langues (normalisé)
      const langTable = pickLanguageTable(doc);
      if (langTable) {
        const normalized = buildNormalizedLangTable(langTable);
        return `<div class="itu-table itu-lang-table-wrap">${normalized.outerHTML}</div>`;
      }

      // 3) fallback : 1er tableau "significatif"
      const tables = Array.from(doc.querySelectorAll('table')).filter(t => t.rows.length > 2);
      if (tables.length > 0) {
        const table = minimalizeTable(tables[0]);
        return `<div class="itu-table">${table.outerHTML}</div>`;
      }

      // 4) dernier recours
      const body = doc.body;
      body.querySelectorAll('script, style').forEach(n => n.remove());
      return `<div class="itu-table">${body.innerHTML}</div>`;

    } catch (err) {
      console.error('❌ Extraction failed:', err);
      return `<p>Error loading content: ${err.message}</p>`;
    } finally {
      showSpinner(modal, false);
    }
  }

  // ---------- click handler ----------
  async function handleClick(e) {
    const a = e.target.closest('a');
    if (!a) return;
    if (!a.matches(LINK_SELECTOR)) return;

    if (a.getAttribute('data-open') === 'modal') {
      e.preventDefault();
      e.stopPropagation();
    } else {
      return; // new tab / normal behavior
    }

    const url = a.href;
    const modal = buildModal();
    const content = modal.querySelector('.summary-body');
    const titleEl = modal.querySelector('.summary-title');
    if (!content || !titleEl) return;

    const userSelector = a.getAttribute('data-extract-selector');
    const title = a.getAttribute('data-modal-title') || a.textContent.trim() || '';

    titleEl.textContent = title;
    content.innerHTML = '';
    showSpinner(modal, true);
    openModal(modal);

    const selectors = userSelector
      ? [userSelector, ...EXTRACT_SELECTOR.split(',').map(s => s.trim())]
      : EXTRACT_SELECTOR.split(',').map(s => s.trim());

    try {
      const extractedHTML = await loadAndInject(url, selectors, modal);
      const wrapper = document.createElement('div');
      wrapper.innerHTML = extractedHTML;
      wrapper.querySelectorAll('a').forEach(link => {
        const href = link.getAttribute('href');
        if (href) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      });
      content.innerHTML = '';
      content.appendChild(wrapper);
    } catch (err) {
      console.warn('CORS/fetch failed, loading iframe', err);
      showSpinner(modal, false);
      loadInIframe(url, modal, title);
    }
  }

  // ---------- init ----------
  function init() {
    document.addEventListener('click', handleClick);
    console.log('✅ SummaryToTable modal initialized (normalized language table + icons)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
